var base = require('settings/api/tokens');

Vue.component('spark-tokens', {
    mixins: [base],
    data(){
        return {
            edit_modal: false,
            delete_modal: false,
            headers: [{
                text: 'Name', value: 'name',  align: 'left'
            },{
                text: 'Last Used', value: 'last_used_at', align: 'left'
            },{
                value: 'edit', sortable: false
            },{
                value: 'delete', sortable: false
            }]
        };
    },

    methods: {
        /**
         * Show the edit token modal.
         */
        editToken(token) {
            this.updatingToken = token;

            this.initializeUpdateFormWith(token);

            this.edit_modal = true;
        },


        /**
         * Update the token being edited.
         */
        updateToken() {
            var self = this;
            Spark.put(`/settings/api/token/${this.updatingToken.id}`, this.updateTokenForm)
                .then(response => {
                    this.$parent.$emit('updateTokens');

                    this.edit_modal = false;
                });
        },

        /**
         * Initialize the edit form with the given token.
         */
        initializeUpdateFormWith(token) {
            this.updateTokenForm.name = token.name;

            if(token.metadata.abilities){
                this.updateTokenForm.abilities = token.metadata.abilities;
            }
        },

        /**
         * Get user confirmation that the token should be deleted.
         */
        approveTokenDelete(token) {
            this.deletingToken = token;

            this.delete_modal = true;
        },


        /**
         * Delete the specified token.
         */
        deleteToken() {
            Spark.delete(`/settings/api/token/${this.deletingToken.id}`, this.deleteTokenForm)
                .then(() => {
                    this.$parent.$emit('updateTokens');

                    this.delete_modal = false;
                });
        }
    }
});
